export const cardConstants = {
  CREATE_CARD_REQUEST: "CREATE_CARD_REQUEST",
  CREATE_CARD_SUCCESS: "CREATE_CARD_SUCCESS",
  CREATE_CARD_FAILURE: "CREATE_CARD_FAILURE",

  ADD_CARD_TO_DECKS_REQUEST: "ADD_CARD_TO_DECKS_REQUEST",
  ADD_CARD_TO_DECKS_SUCCESS: "ADD_CARD_TO_DECKS_SUCCESS",
  ADD_CARD_TO_DECKS_FAILURE: "ADD_CARD_TO_DECKS_FAILURE",

  UPDATE_CARD_DATA_REQUEST: "UPDATE_CARD_DATA_REQUEST",
  UPDATE_CARD_DATA_SUCCESS: "UPDATE_CARD_DATA_SUCCESS",
  UPDATE_CARD_DATA_FAILURE: "UPDATE_CARD_DATA_FAILURE",

  DELETE_CARD_REQUEST: "DELETE_CARD_REQUEST",
  DELETE_CARD_SUCCESS: "DELETE_CARD_SUCCESS",
  DELETE_CARD_FAILURE: "DELETE_CARD_FAILURE",

  UPDATE_CARD_REQUEST: "UPDATE_CARD_REQUEST",
  UPDATE_CARD_SUCCESS: "UPDATE_CARD_SUCCESS",
  UPDATE_CARD_FAILURE: "UPDATE_CARD_FAILURE",

  FETCH_CARD_REQUEST: "FETCH_CARD_REQUEST",
  FETCH_CARD_SUCCESS: "FETCH_CARD_SUCCESS",
  FETCH_CARD_FAILURE: "FETCH_CARD_FAILURE",

  UPDATE_CARDS_PASSAGE_REQUEST: "UPDATE_CARDS_PASSAGE_REQUEST",
  UPDATE_CARDS_PASSAGE_SUCCESS: "UPDATE_CARDS_PASSAGE_SUCCESS",
  UPDATE_CARDS_PASSAGE_FAILURE: "UPDATE_CARDS_PASSAGE_FAILURE",

  FETCH_ALL_CARDS_REQUEST: "FETCH_ALL_CARDS_REQUEST",
  FETCH_ALL_CARDS_SUCCESS: "FETCH_ALL_CARDS_SUCCESS",
  FETCH_ALL_CARDS_FAILURE: "FETCH_ALL_CARDS_FAILURE",

  FETCH_CARD_PASSAGE_REQUEST: "FETCH_CARD_PASSAGE_REQUEST",
  FETCH_CARD_PASSAGE_SUCCESS: "FETCH_CARD_PASSAGE_SUCCESS",
  FETCH_CARD_PASSAGE_FAILURE: "FETCH_CARD_PASSAGE_FAILURE",

  FETCH_CARD_DECKS_REQUEST: "FETCH_CARD_DECKS_REQUEST",
  FETCH_CARD_DECKS_SUCCESS: "FETCH_CARD_DECKS_SUCCESS",
  FETCH_CARD_DECKS_FAILURE: "FETCH_CARD_DECKS_FAILURE"
}
